export default "__VITE_ASSET__BOw07fmR__"